import React from "react";
import { Button, PerexBox } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AdvancedSetup } from "../../elements/AdvancedSetup";
import { NextIcon } from "../../elements/Icons";
import GoogleWizardHeader from "../../elements/MetaWizard/GoogleWizardHeader";
import { MonthlyBudget } from "../../elements/MonthlyBudget";
import { ProgressStepper, StepsT } from "../../elements/ProgressStepper";
import WizardHeader from "../../elements/WizardHeader";
import { AdSystemT, WizardStepT, useLeaveWizardMutation, useOrganizationQuery } from "../../graphql/generated/graphql";
import { useRecommendedMonthlyBudget } from "../../hooks/useRecommendedMonthlyBudget";
import { useWizardState } from "../../hooks/useWizardState";
import { useSetWizardStepEffect } from "./useSetWizardStepEffect";

type FirstPagePropsT = {
  hasMetaCampaignsEnabled: boolean;
};

export const FirstPage = ({ hasMetaCampaignsEnabled }: FirstPagePropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard First Page" });
  useSetWizardStepEffect({ wizardStep: WizardStepT.FirstT });
  const { recommendedMonthlyBudget } = useRecommendedMonthlyBudget();
  const { data: organizationData } = useOrganizationQuery();
  const { googleWizardFinished, metaWizardFinished } = useWizardState();
  const atLeastOneCampaignFinished = googleWizardFinished || metaWizardFinished;
  const navigate = useNavigate();
  const [leaveWizard] = useLeaveWizardMutation();

  const backButtonHandler = async () => {
    await leaveWizard({ variables: { adSystem: AdSystemT.GoogleAdsT } }).catch(() => undefined);
    navigate("/wizard/new-campaign-selection");
  };

  return (
    <div>
      {hasMetaCampaignsEnabled && <WizardHeader />}
      <GoogleWizardHeader />
      <ProgressStepper currentStep={StepsT.STEP_SETUP} />
      {organizationData?.organization?.archivedAt && <PerexBox>{t("Archived Info")}</PerexBox>}
      <PerexBox>{t("InfoBox")}</PerexBox>

      <h2>{t("Monthly Budget Headline")}</h2>
      <p>
        <Trans
          components={{ strong: <strong /> }}
          i18nKey="Monthly Budget Text with budget"
          t={t}
          values={{ recommendedMonthlyBudget }}
        />
      </p>

      <MonthlyBudget />
      <br />
      <AdvancedSetup />
      <br />
      <br />
      <br />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {hasMetaCampaignsEnabled && (
          <>
            {atLeastOneCampaignFinished && <div />}
            {!atLeastOneCampaignFinished && (
              <Button variant="secondary" onClick={backButtonHandler}>
                {t("Back")}
              </Button>
            )}
          </>
        )}
        {!hasMetaCampaignsEnabled && <div />}
        <Button data-test-id="continue-to-next-step" onClick={() => navigate("/wizard/suggestion-generator")}>
          <span style={{ display: "flex", alignItems: "center" }}>
            {t("Continue to next step")}
            &nbsp;
            <NextIcon />
          </span>
        </Button>
      </div>
    </div>
  );
};
